import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Recibís acceso inmediato a una plataforma donde podés descargar todos los PDFs y materiales editables. Te llega un mail automático al instante de la compra.'
  }, {
    q: '¿Sirve para cualquier año de la carrera de Medicina?',
    a: 'Sí, el sistema está pensado para acompañarte desde el primer día hasta la residencia. Los tomos cubren las materias troncales de todos los años.'
  }, {
    q: '¿Sirve si recién arranqué la carrera?',
    a: 'Es el mejor momento. El Nivel 1 incluye el Tomo 01 sobre Método de Estudio y Organización, ideal para no perder tiempo probando técnicas que no funcionan en primer año.'
  }, {
    q: '¿Funciona para estudiar para finales difíciles?',
    a: 'Totalmente. Los tomos están filtrados con los temas más tomados y organizados para repaso rápido (Active Recall), ideal para finales pesados como Anatomía o Farmacología.'
  }, {
    q: '¿Los materiales editables de qué nivel son?',
    a: 'Los 7 editables premium son exclusivos del Nivel 3 (Sistema de Gestión Académica™).'
  }, {
    q: '¿Qué diferencia hay entre los 3 niveles?',
    a: 'El Nivel 1 tiene la base (6 tomos + 6 bonos). El Nivel 2 suma los tomos clínicos (Guardia y Medicina Interna). El Nivel 3 suma los 7 editables premium para organizar toda tu cursada.'
  }, {
    q: '¿Qué pasa si tengo materias con mucho contenido teórico?',
    a: "Nuestros resúmenes están diseñados para sintetizar la teoría extensa en esquemas, mnemotecnias y puntos clave, eliminando la 'paja' de los libros tradicionales."
  }, {
    q: '¿Qué diferencia tiene con apuntes o resúmenes del mercado?',
    a: 'No son simples resúmenes desgrabados. Es un sistema estructurado pedagógicamente, actualizado, revisado y enfocado en lo que realmente evalúan los docentes.'
  }, {
    q: '¿Funciona para cualquier universidad?',
    a: 'Sí. Está construido cruzando los planes de estudio oficiales de UBA, UNLP, UNC, UNR y las principales facultades del país. La medicina es la misma.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, 100% real. Tenés 7 días para probarlo. Si no te sirve, nos mandás un mail y te devolvemos el dinero sin hacerte preguntas.'
  }];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <div className="text-center mb-12" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-127">
            Preguntas frecuentes
          </h2>
          <p className="text-lg text-slate-600" data-id="element-128">
            Todo lo que necesitás saber antes de decidir.
          </p>
        </div>

        <div className="space-y-4" data-id="element-129">
          {faqs.map((faq, idx) => <div key={idx} className="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-130">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-slate-50 transition-colors focus:outline-none" data-id="element-131">
                <span className="font-bold text-slate-800 pr-4" data-id="element-132">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === idx ? 45 : 0
            }} transition={{
              duration: 0.2
            }} className="shrink-0 text-brand-blue" data-id="element-133">
                  <Plus size={20} data-id="element-134" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-135">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-136">
                    <div className="px-6 pb-4 pt-2 text-slate-600 border-t border-slate-100" data-id="element-137">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}